// extracted by mini-css-extract-plugin
export var cancelButton = "_o2-5";
export var content = "_o2-3";
export var createButton = "_o2-6";
export var drawerContainer = "_o2-0";
export var footer = "_o2-2";
export var header = "_o2-1";
export var orderFormColumn = "_o2-4";